module.exports = __webpack_public_path__ + "img/icon_add.4311fb2f.svg";